import Firebase from "../firebase";

const useFetch = (method: string): any => {
  const execute = async ({ url, body }: { url: string; body?: object }) => {
    const token = await Firebase.getToken();
    let res = null;

    switch (method) {
      case "GET":
        res = await fetch(url, {
          method: method,
          headers: { Authorization: "Bearer " + token }
        });
        const getResponseJson = await res.json();
        return getResponseJson;
      case "POST":
        res = await fetch(url, {
          method: method,
          headers: { Authorization: "Bearer " + token },
          body: JSON.stringify(body)
        });
        if (res.status === 400 || res.status === 500) {
          alert(await res.text());
        } else if (res.status === 201) {
          const postResponseJson = await res.json();
          return postResponseJson;
        }
        break;
      case "PUT":
        await fetch(url, {
          method: method,
          headers: { Authorization: "Bearer " + token },
          body: JSON.stringify(body)
        });
        break;
      case "DELETE":
        await fetch(url, {
          method: method,
          headers: { Authorization: "Bearer " + token }
        });
        break;
      default:
        console.log("other");
    }
  };

  return { execute };
};

export default useFetch;
